export const GET_BOOKING_REQUEST = "GET_BOOKING_REQUEST";
export const GET_BOOKING_SUCCESS = "GET_BOOKING_SUCCESS";
export const GET_BOOKING_FAIL = "GET_BOOKING_FAIL";
export const DELETE_BOOKING = "DELETE_BOOKING";